module.exports = __webpack_public_path__ + "img/logo_bpo.6180dcf6.svg";